import React from 'react';
import DataTable from 'react-data-table-component';
import EventScheduleActions from './Actions/EventScheduleActions';

import { Component } from 'react';

class List extends Component {

  render() {

    const columns = [
      {
        name: 'Type',
        width: '200px',
        sort: false,
        cell: row => {
          return <div>
            <b>{row.telehealthType ? row.telehealthType === 'video' ? 'Real Time' : 'Async' : ''} {row.type}</b> <br />
            <b>{row.type === 'Telehealth' ? "Pre-Visit: " : "Title: "}</b>
            {row.type === 'Telehealth' ? row.preVisitQuestions && row.preVisitQuestions.name : row.form && row.form.name}
          </div>
        }
      },
      {
        name: 'Date',
        width: '200px',
        sort: false,
        cell: row => {
          return <div>
            <b>{row.type === 'Telehealth' ? "Telehealth Date: " : "Complete By: "}</b><br /> {row.date}
          </div>
        }
      },
      {
        name: 'Available On',
        width: '200px',
        sort: false,
        cell: row => {
          return <div>
            {row.availableOn}
          </div>
        }
      },
      {
        name: 'Treating Provider',
        sort: false,
        cell: row => {
          return row.doctor.name
        }
      },
      {
        name: 'Location',
        sort: false,
        cell: row => {
          return row.providerGroup.name
        }
      },
      {
        button: true,
        sort: false,
        cell: (row) => {
          return (
            <EventScheduleActions
              setValue={this.props.setValue}
              eventItem={row}
              eventItems={this.props.eventItems}
              rescheduleItem={this.props.rescheduleEventItem}
            />
          )
        }
      }
    ];

    return (
      <div className="row">
        <div className="col-lg-12 mt-3">
          <div className="row">
            <div className="col-lg-12">
              <DataTable
                data={this.props.eventItems}
                columns={columns}
                striped={true}
                noHeader={true}
                customStyles={{ cells: { style: { fontSize: '14px' }, }, }}
                noDataComponent="There are no event items to display"
              />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default List;